import React from "react";
import type { Task } from "@services/vesselCall/types";
import ApproveVesselCall from "./approve/ApproveVesselCall";
import CancelVesselCall from "./cancel/CancelVesselCall";
import ClaimResumeCall from "./ClaimResumeCall";
import ClaimVesselCall from "./ClaimVesselCall";
import CloseVesselCallButton from "./CloseVesselCallButton";
import DelegateVesselCall from "./DelegateVesselCall";
import DeleteCallDraft from "./DeleteCallDraft";
import EditDraft from "./EditDraft";
import InterruptVesselCall from "./interrupt/InterruptVesselCall";
import PreApproveVesselCall from "./pre-approve/PreApproveVesselCall";
import PreRejectVesselCall from "./pre-reject/PreRejectVesselCall";
import RejectResumption from "./reject-resumption/RejectResumption";
import RejectVesselCall from "./reject/RejectVesselCall";
import ResumeVesselCall from "./resume/ResumeVesselCall";
import ResumptionVesselCall from "./resumption/ResumptionVesselCall";
import UnclaimResumeCall from "./UnclaimResumeCall";
import UnclaimVesselCall from "./UnclaimVesselCall";
import UpdateVesselCall from "./UpdateVesselCall";
import UpdateVesselCallETA from "./UpdateVesselCallETA";

interface VesselCallFlowButtonsProps {
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
  refetchInterruption: () => Promise<unknown>;
  vesselCallFlowData?: {
    vesselCallId: string;
    originalVesselCallId?: string;
    task: Task | null;
    status: string;
    companyId: string;
    movementStatus?: string;
    roles?: string[];
  };
  onUpdateVesselCall: () => void;
  setIsConfirmDiscardDraftOpen: (isOpen: boolean) => void;
  showUpdateButton?: boolean;
  onUpdateEta?: () => void;
  interruptionTaskStatus?: string;
  claimOwnerName?: string;
  canCloseVesselCall?: boolean;
}

const VesselCallFlowButtons: React.FC<VesselCallFlowButtonsProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
  refetchInterruption,
  onUpdateVesselCall,
  setIsConfirmDiscardDraftOpen,
  showUpdateButton,
  onUpdateEta,
  interruptionTaskStatus,
  claimOwnerName,
  canCloseVesselCall = false,
}) => {
  return (
    <div className="flex gap-4">
      <ClaimVesselCall
        vesselCallFlowData={vesselCallFlowData}
        refetchVesselCall={refetchVesselCall}
      />
      <UnclaimVesselCall
        vesselCallFlowData={vesselCallFlowData}
        refetchVesselCall={refetchVesselCall}
      />
      <CloseVesselCallButton
        isVisible={canCloseVesselCall}
        vesselCallFlowData={vesselCallFlowData}
        refetchVesselCall={refetchVesselCall}
        openDrawer={openDrawer}
      />
      <DelegateVesselCall vesselCallFlowData={vesselCallFlowData} />
      <PreRejectVesselCall vesselCallFlowData={vesselCallFlowData} openDrawer={openDrawer} />
      <PreApproveVesselCall
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
      />
      <RejectVesselCall vesselCallFlowData={vesselCallFlowData} openDrawer={openDrawer} />
      <ApproveVesselCall
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
      />
      <UpdateVesselCall
        vesselCallFlowData={vesselCallFlowData}
        onUpdateVesselCall={onUpdateVesselCall}
      />
      <UpdateVesselCallETA
        vesselCallFlowData={vesselCallFlowData}
        showUpdateButton={showUpdateButton}
        onUpdateEta={onUpdateEta}
      />
      <InterruptVesselCall
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
      />
      <ResumeVesselCall vesselCallFlowData={vesselCallFlowData} openDrawer={openDrawer} />
      <ResumptionVesselCall
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
        interruptionTaskStatus={interruptionTaskStatus}
        claimOwnerName={claimOwnerName}
      />
      <RejectResumption
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
        interruptionTaskStatus={interruptionTaskStatus}
        claimOwnerName={claimOwnerName}
      />
      <ClaimResumeCall
        vesselCallFlowData={vesselCallFlowData}
        refetchVesselCall={refetchVesselCall}
        refetchInterruption={refetchInterruption}
        interruptionTaskStatus={interruptionTaskStatus}
      />
      <UnclaimResumeCall
        vesselCallFlowData={vesselCallFlowData}
        refetchVesselCall={refetchVesselCall}
        refetchInterruption={refetchInterruption}
        interruptionTaskStatus={interruptionTaskStatus}
        claimOwnerName={claimOwnerName}
      />
      <DeleteCallDraft
        vesselCallFlowData={vesselCallFlowData}
        setIsConfirmDiscardDraftOpen={setIsConfirmDiscardDraftOpen}
      />
      <EditDraft vesselCallFlowData={vesselCallFlowData} />
      <CancelVesselCall
        vesselCallFlowData={vesselCallFlowData}
        openDrawer={openDrawer}
        refetchVesselCall={refetchVesselCall}
      />
    </div>
  );
};

export default VesselCallFlowButtons;
